import * as React from "react";
import * as main from "../../../styles/main.module.scss";
import * as screen4 from "./screen4.module.scss";

export const ResultsAndReviewsTop = ({ data }) => {
  return (
    <section className={screen4.videoReviews}>
      <div className={`container ${screen4.videoReviews__container}`}>

        <div className={screen4.videoReviews__content}>
          <div className={screen4.reviewsText__block}>
            <h2 className={main.title2}>Проходя курс, ребёнок освоит:</h2>
            <div className={screen4.reviewsSubext__block}>
              <img
                src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya/icon-programm-1.png"
                alt={""}
                className={screen4.reviewsSubtext__img}
              />
              <div className={screen4.reviewsSubext__description}>
                <h3 className={screen4.reviewsSubext__title}>Теорию в динамичных видео </h3>
                <p className={screen4.reviewsSubext__content}>в формате мини-тренингов. Преподаватель объясняет, как применять
                  различные техники, которые ребёнок сразу же отрабатывает на практике.</p>
              </div>
            </div>
            <div className={screen4.reviewsSubext__block}>
              <img
                src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya/icon-programm-2.png"
                alt={""}
                className={screen4.reviewsSubtext__img}
              />
              <div className={screen4.reviewsSubext__description}>
                <h3 className={screen4.reviewsSubext__title}>Интерактивные тренажёры —</h3>
                <p className={screen4.reviewsSubext__content}>на них ребёнок доводит навыки до автоматизма. Тренироваться можно
                  неограниченное количество раз, наращивая темп. Контролировать скорость помогает встроенный таймер.</p>
              </div>
            </div>
            <div className={screen4.reviewsSubext__block}>
              <img
                src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya/icon-programm-3.png"
                alt={""}
                className={screen4.reviewsSubtext__img}
              />
              <div className={screen4.reviewsSubext__description}>
                <h3 className={screen4.reviewsSubext__title}>Разминочные и развивающие упражнения —</h3>
                <p className={screen4.reviewsSubext__content}>ими начинается и заканчивается каждое занятие. Цель разминочных
                  упражнений — помочь настроиться на продуктивную интеллектуальную работу и привить полезную привычку
                  входить в ресурсное состояние перед любым обучением или работой. Эти упражнения так же развивают
                  навыки работы с информацией и скорочтения. </p>
              </div>
            </div>
          </div>
          <div className={screen4.reviewsUndertext__block}>
            <h3 className={screen4.reviewsUndertext__title}>Что развивает курс:</h3>
            <div className={screen4.reviewsUndertext__list}>
              <div className={screen4.reviewsUndertext__list}>
                <div className={screen4.reviewsUndertext__listItem}>
                  <div className={screen4.reviewsUndertext__listTitle}>интеллектуальные способности</div>
                  <div className={screen4.reviewsUndertext__listText}>(память, внимание, воображение, логику, скорость
                    мышления)
                  </div>
                </div>
                <div className={screen4.reviewsUndertext__listItem}>
                  <div className={screen4.reviewsUndertext__listTitle}>навыки чтения</div>
                  <div className={screen4.reviewsUndertext__listText}>(качество понимания и скорость)</div>
                </div>
                <div className={screen4.reviewsUndertext__listItem}>
                  <div className={screen4.reviewsUndertext__listTitle}>навыки работы с различными видами информации</div>
                  <div className={screen4.reviewsUndertext__listText}>(выделение главного, структурирование, запоминание).
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={screen4.reviewsUndertext__blockMobile}>
          <h3 className={screen4.reviewsUndertext__title}>Что развивает курс:</h3>
          <div className={screen4.reviewsUndertext__list}>
            <div className={screen4.reviewsUndertext__list}>
              <div className={screen4.reviewsUndertext__listItem}>
                <div className={screen4.reviewsUndertext__listTitle}>интеллектуальные способности</div>
                <div className={screen4.reviewsUndertext__listText}>(память, внимание, воображение, логику, скорость
                  мышления)
                </div>
              </div>
              <div className={screen4.reviewsUndertext__listItem}>
                <div className={screen4.reviewsUndertext__listTitle}>навыки чтения</div>
                <div className={screen4.reviewsUndertext__listText}>(качество понимания и скорость)</div>
              </div>
              <div className={screen4.reviewsUndertext__listItem}>
                <div className={screen4.reviewsUndertext__listTitle}>навыки работы с различными видами информации</div>
                <div className={screen4.reviewsUndertext__listText}>(выделение главного, структурирование, запоминание).</div>
              </div>
            </div>
          </div>
        </div>

        <div className={screen4.videoReviews__row}>

          {data.map((elem, index) => (
            <div className={screen4.videoReviews__col} key={index}>
              <div className={screen4.videoReviews__videoContainer}>
                <iframe
                  width="324"
                  height="175"
                  src={elem.source}
                  title={elem.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen/>
              </div>
              <div className={screen4.videoReviews__informationWrapper}>
                <p className={screen4.videoReviews__name}>{elem.name}</p>
                <div className={screen4.videoReviews__quote}>
                  <p className={screen4.videoReviews__quoteText}>{elem.quote ? elem.quote : null}</p>
                </div>
              </div>
            </div>
          ))}

        </div>
      </div>
    </section>
  );
};
